/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */

import { jsx } from "@emotion/core"
import { Link } from "react-router-dom"
import { Row, Col, Button, Tag } from "grab-ui"
import { useTranslationsMap } from "common/utils/i18n"
import { CREATE_CATALOGUE, CREATE_MENU } from "constants/routes"
import { useIsMartMenuGroup } from "pages/menu-groups"
import { TroyWebTracker } from "utils/tracking"
import { EventAction, EventCategory } from "constants/tracking"
import { useSelector } from "react-redux"
import { AppState } from "store/store.type"
import {
  announcementBannerContainer,
  announcementBannerDescription,
  announcementBannerTag,
  announcementBannerTitle,
} from "./styles"

export const MultiStoreMenuAnnouncementBanner = () => {
  const {
    menu: { merchantGroupID },
  } = useSelector((state: AppState) => state)

  const isMartMenuGroup = useIsMartMenuGroup()

  const textMap = useTranslationsMap({
    title: "menu.list.multiStoreMenu.banner.title",
    description: "menu.list.multiStoreMenu.banner.description",
    createNewMenu: `menu.menuGroup.create.${
      isMartMenuGroup ? "forCatalogue" : "forMenu"
    }.createNewMenuBtn`,
    new: "menu.button.new",
  })

  return (
    <div css={announcementBannerContainer}>
      <Tag color="orange" css={announcementBannerTag}>
        {textMap.new.toUpperCase()}
      </Tag>
      <Row type="flex" align="middle" justify="space-between" gutter={16}>
        <Col>
          <Row type="flex" align="middle" gutter={16}>
            <Col>
              <img src={require("../../assets/images/announcement.svg")} />
            </Col>
            <Col>
              <p css={announcementBannerTitle}>{textMap.title}</p>
              <p css={announcementBannerDescription}>{textMap.description}</p>
            </Col>
          </Row>
        </Col>
        <Col>
          <Link
            data-testid="link-button"
            onClick={() => {
              TroyWebTracker.sendEvent({
                category: EventCategory.menuGroupHomePage,
                action: EventAction.clickCreateNewMenu,
                labels: {
                  MERCHANT_GROUP_ID: merchantGroupID,
                },
              })
            }}
            to={isMartMenuGroup ? CREATE_CATALOGUE : CREATE_MENU}
          >
            <Button type="primary">{textMap.createNewMenu}</Button>
          </Link>
        </Col>
      </Row>
    </div>
  )
}
